// extracted by mini-css-extract-plugin
export default {"botao":"botao_botao__a61ze"};